export default __webpack_public_path__ + "static/media/Done.a1397aff.svg";